magna.flavorBlock = {
  activeClass: 'flavors__name--active',
  bodyActiveClass: 'flavors__description--active',
  elements: document.querySelectorAll('.flavors__name'),
  images: document.querySelectorAll('.flavors__flav'),
  imageLength: document.querySelectorAll('.flavors__flav').length,
  container: document.querySelector('.flavors__carousel'),
  allImages: () => {
    return Array.from(document.querySelectorAll('.flavors__name')).map((item, index) => {
      const imagesLen = document.querySelectorAll('.flavors__flav').length
      const totalWidth =
        document.querySelector('.flavors__carousel').getBoundingClientRect().width * imagesLen
      const division = totalWidth / document.querySelectorAll('.flavors__name').length
      return division * index * -1
    })
  },
}

magna.flavorBlock.toggleFlavor = (event, index) => {
  const flavor = event.currentTarget.id
  const body = document.querySelector(`[data-id="${flavor}"]`)
  const bodies = document.querySelectorAll('.flavors__description')
  const allImages = magna.flavorBlock.allImages()

  bodies.forEach(el => el.classList.remove(magna.flavorBlock.bodyActiveClass))
  magna.flavorBlock.elements.forEach(el => el.classList.remove(magna.flavorBlock.activeClass))
  magna.flavorBlock.container.style.transform = `translate3d(${allImages[index]}px, 0px, 0px)`
  event.currentTarget.classList.add(magna.flavorBlock.activeClass)
  body.classList.add(magna.flavorBlock.bodyActiveClass)
}

magna.flavorBlock.init = () => {
  magna.flavorBlock.elements?.forEach((item, index) =>
    item?.addEventListener('click', event => magna.flavorBlock.toggleFlavor(event, index)),
  )
  magna.flavorBlock.elements[0]?.click()
}
